---
title: Community and resources
---

- Design Systems Slack
- Design Ops Slack
- Animations Chat
- Sidebar.io
- Figma Newsletter
- news.ycombinator
